
export const environment = {
  production: true,
  serverPath:'https://wa.utiliadmin.com/',
  tokenIssuerClient: "https://www.utiliportal.com",
  tokenIssuerPath: "https://wa.utiliportal.com"
};
